"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#4285F4",
    d: "M12.163 10.42v3.04h4.394c-.193.977-.772 1.805-1.64 2.361l2.649 1.976C19.11 16.427 20 14.416 20 12.026q-.002-.835-.148-1.605z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#34A853",
    d: "m7.588 13.341-.597.44-2.115 1.583c1.343 2.562 4.096 4.33 7.287 4.33 2.204 0 4.052-.698 5.403-1.897l-2.65-1.976c-.727.47-1.655.756-2.753.756a4.86 4.86 0 0 1-4.571-3.231z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#FBBC05",
    d: "M4.876 8.33a7.51 7.51 0 0 0 0 7.034c0 .007 2.716-2.026 2.716-2.026-.163-.47-.26-.97-.26-1.49 0-.522.097-1.02.26-1.492z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#EA4335",
    d: "M12.163 7.125c1.203 0 2.271.4 3.125 1.17l2.337-2.248C16.208 4.777 14.367 4 12.163 4 8.973 4 6.22 5.762 4.876 8.33l2.716 2.026a4.86 4.86 0 0 1 4.571-3.231"
  })]
}), 'Google');
//# sourceMappingURL=index.js.map